import { Money } from '@dreryk/money-common-api';

import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

type PaidAmountTextViewProps = {
   readonly paidAmount: Money;
};

export const PaidAmountTextView = (props: PaidAmountTextViewProps): JSX.Element => {
   return (
      <TextView testId={'paidAmount'} label={invoiceCreateModalTranslationKeys.payment}>
         {priceFormatter(
            props.paidAmount.asNumber(),
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: false,
               },
            })
         )}
      </TextView>
   );
};
